module.exports = __webpack_public_path__ + "img/36.5cf639ef.svg";